import rangeSlider from 'range-slider-input';

class Slider {
    constructor(section) {
        this.section = section
        this.textMax = this.section.querySelector('.range-slider-text-max');
        this.textMin = this.section.querySelector('.range-slider-text-min');
        this.inputTargetsJson = this.section.getAttribute('data-input-targets');
    }

    init() {
        console.log('Slider Initialization')
        const element = this.section.querySelector('.range-slider');
        const options = this.options;
        if(this.inputTargetsJson) {
            const inputTargets = JSON.parse(this.inputTargetsJson);
            console.log(inputTargets.targets[0])
            const inputTargetMin = this.section.querySelector(inputTargets.targets[0]);
            const inputTargetMax = this.section.querySelector(inputTargets.targets[1]);
            
            if(this.textMax && this.textMin) {
                options.onInput = (value) => {
                    this.textMax.textContent = this.formatter.format(value[1] / 100);
                    this.textMin.textContent = this.formatter.format(value[0] / 100);
                    console.log(value)
                    inputTargetMin.value = value[0] / 100;
                    inputTargetMax.value = value[1] / 100;
                }
            }
        }
        

        
        const rangeSliderElement = rangeSlider(element, options);
    }

    get options() { 
        return this.section.getAttribute('data-range-options') ? JSON.parse(this.section.getAttribute('data-range-options')) : {}
    }

    get formatter() {
        return new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
            style: 'currency',
            currency: `${Shopify.currency.active}`,
          });
    }
}

export default Slider;